import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { CardTypeThree } from "../../Common/Cards";
import { languageService } from "../../../Language/language.service";
import { getStatusColor } from "../../../utils/statusColors";
import { CRUDFunction } from "../../../reduxCURD/container";
import { themeService } from "../../../theme/service/activeTheme.service";
import { commonStylesDashboard } from "../../Dashboard/styles/commonStylesDashboard";
import PropagateLoader from "react-spinners/PropagateLoader";

class WorkOrderActivityWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widgetData: null,
      spinnerLoading: false,
    };
    this.getCombinedData = this.getCombinedData.bind(this);
    this.fetchCall = this.fetchCall.bind(this);
  }
  fetchCall(settings, dateRange, filterLocations) {
    let sett = settings.map((s) => {
      return { ...s, lineIds: filterLocations };
    });
    // const url = `summary?settings=${JSON.stringify(sett)}&dateRange=${JSON.stringify(dateRange)}`;

    // this.props.getWorkOrderStatusSummaryWidgets(url);
    this.props.createWorkOrderStatusSummaryWidget(
      {
        settings: sett,
        dateRange: dateRange,
      },
      "WidgetSettings",
      "/summary",
    );
  }
  componentDidMount() {
    const { settings } = this.props.settings;
    const { dateRange, filterLocations } = this.props;
    this.fetchCall(settings, dateRange, filterLocations);
  }

  componentDidUpdate(prevProps) {
    const {
      settings: { settings },
      dateRange,
      actionType,
      filterLocations,
      workOrderStatusSummaryWidgets,
    } = this.props;

    const { dateRange: prevDateRange, actionType: prevActionType, filterLocations: prevFilterLocations } = prevProps;
    const dateChanged = dateRange.month !== prevDateRange.month || dateRange.year !== prevDateRange.year;
    const filtersChanged = filterLocations !== prevFilterLocations;

    if (dateChanged || filtersChanged) {
      this.fetchCall(settings, dateRange, filterLocations);
    }

    if (actionType !== prevActionType) {
      if (actionType === "WORKORDERSTATUSSUMMARYWIDGET_CREATE_REQUEST") {
        this.setState({ spinnerLoading: true });
      } else if (actionType === "WORKORDERSTATUSSUMMARYWIDGET_CREATE_SUCCESS") {
        this.setState({
          spinnerLoading: false,
          widgetData: workOrderStatusSummaryWidgets,
        });
      } else if (actionType === "WORKORDERSTATUSSUMMARYWIDGET_CREATE_FAILURE") {
        console.error("Failed to fetch widget data.");
        this.setState({ spinnerLoading: false });
      }
    }
  }

  getCombinedData() {
    const { widgetData } = this.state;
    let maintenanceSummary = widgetData ? widgetData.maintenanceSummary : {};
    let summary = { workOrdersCreated: 0, workOrdersClosed: 0, workOrdersPerformed: 0 };

    if (maintenanceSummary && maintenanceSummary.lines) {
      Object.entries(maintenanceSummary.lines).forEach(([id, val]) => {
        summary.workOrdersCreated += val.summary.workOrdersCreated;
        summary.workOrdersClosed += val.summary.workOrdersClosed;
        summary.workOrdersPerformed += val.summary.workOrdersPerformed;
      });
    }
    return summary;
  }

  render() {
    const { widgetData, spinnerLoading } = this.state;

    if (spinnerLoading || !widgetData) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
          <PropagateLoader
            color={themeService({ default: "rgb(55, 139, 119)", retro: "var(--first)", electric: "rgba(64, 118, 179,.5)" })}
            sizeUnit={"px"}
            size={10}
          />
        </div>
      );
    }

    let data = this.getCombinedData();

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <Row style={themeService(commonStylesDashboard.summaryHeading)}>{languageService("Work Order")}</Row>
        </div>
        <Row style={{ gap: "20px", paddingInline: "15px" }}>
          <Col style={{ padding: 0, margin: 0 }}>
            {" "}
            <CardTypeThree number={data.workOrdersCreated} numberColor={getStatusColor("New")} text={"Created"} />{" "}
          </Col>
          <Col style={{ padding: 0, margin: 0 }}>
            {" "}
            <CardTypeThree
              number={data.workOrdersPerformed}
              numberColor={getStatusColor("In Progress")}
              text={languageService("Performed Executions")}
            />{" "}
          </Col>
          <Col style={{ padding: 0, margin: 0 }}>
            <CardTypeThree number={data.workOrdersClosed} numberColor={getStatusColor("Completed")} text={"Complete"} />{" "}
          </Col>
        </Row>
      </div>
    );
  }
}

const actionOptions = {
  create: true,
  update: false,
  read: true,
  delete: false,
};

const WOActivityWidgetContainer = CRUDFunction(
  WorkOrderActivityWidget,
  "workOrderStatusSummaryWidget",
  actionOptions,
  null,
  [],
  "dashboard",
);

export default WOActivityWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/NewDashboard/widgets/workOrderActivityWidget.jsx